import { useTranslation } from '../../hooks/useTranslation';

interface RewardsTabsProps {
  activeTab: 'shop' | 'history' | 'mycodes';
  onTabChange: (tab: 'shop' | 'history' | 'mycodes') => void;
  onBack?: () => void;
}

const RewardsTabs = ({ activeTab, onTabChange }: RewardsTabsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      {/* Back button - minimal icon button */}
      {/* <button
        onClick={onBack}
        className="mb-4 flex items-center gap-2 text-gray-400 hover:text-primary transition-colors group"
      >
        <div className="w-8 h-8 rounded-lg bg-gray-800/50 flex items-center justify-center group-hover:bg-gray-700/50 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </div>
        <span className="text-sm font-medium">{t('checkIn.backButton')}</span>
      </button> */}
      
      {/* Tabs - modern segmented control style */}
      <div className="relative bg-gray-900/30 p-1.5 rounded-2xl border border-gray-800/50">
        <div className="flex gap-1.5">
          <button
            onClick={() => onTabChange('shop')}
            className={`flex-1 py-3 px-4 rounded-xl font-bold text-sm transition-all duration-200 ${
              activeTab === 'shop'
                ? 'bg-gradient-to-r from-primary to-yellow-500 text-black shadow-lg shadow-primary/50 scale-[1.02]'
                : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800/30'
            }`}
          >
            {t('checkIn.shop')}
          </button>
          <button
            onClick={() => onTabChange('mycodes')}
            className={`flex-1 py-3 px-4 rounded-xl font-bold text-sm transition-all duration-200 ${
              activeTab === 'mycodes'
                ? 'bg-gradient-to-r from-green-600 to-emerald-500 text-white shadow-lg shadow-green-500/50 scale-[1.02]'
                : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800/30'
            }`}
          >
            {t('checkIn.myCodes')}
          </button>
          <button
            onClick={() => onTabChange('history')}
            className={`flex-1 py-3 px-4 rounded-xl font-bold text-sm transition-all duration-200 ${
              activeTab === 'history'
                ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/50 scale-[1.02]'
                : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800/30'
            }`}
          >
            {t('history.title')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardsTabs;

